import { APICore } from "./apiCore";

const api = new APICore();

function getEnqApi() {
    const baseUrl = "/enquiries";
    
    
  return api.get(`${baseUrl}`, {});
}

function deleteEnqApi(id: number) {
  const baseUrl = `/enquiries/${id}`;
  return api.delete(`${baseUrl}`);
}

export { getEnqApi, deleteEnqApi };
